// removed by extract-text-webpack-plugin
module.exports = {"root":"_1-IKhmM","content":"_2W7rPTd","category":"_2nmeYlH","copyright":"jjW5hxv","heading":"_1hGc4qm","copyrightMessage":"_2DlC25-","navLink":"_30sVPGA","secondaryLink":"_2ghuJtK","toggle":"_9Rszi1h","toggleContainer":"_3gYXzUF","chevron":"_2jpby0T","chevronSvg":"_1U5QvFu","toggleLabel":"_1iLG349","internationalPartnerCountry":"_1ezY5Dl"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Footer/Footer.less
 ** module id = 741
 ** module chunks = 0
 **/